import React from 'react'
import styled from 'styled-components'
import {BodyText} from './text.js'
import theme from './theme.js'
import Link from './link.js'
import SubItem from './header-menu-main-mobile-sub-item.js'

const UnstyledMenuItem = ({
  className,
  entry
}) => {
  const props = {
    className 
  }

  const title = entry.title
  const items = entry.subItems

  const SubMenuTest = () => {
    if (!items) return null

    const subItems = entry.subItems.map(entry => {
      const props = {
        key: entry.key,
        entry
      }
  
      return <SubItem {...props}/>
    })

    return (
      <SubMenu>
        {subItems}
      </SubMenu>
    )
  }

  return (
    <div {...props}>
      <Link {...entry}>
        <Title>{title}</Title>
      </Link>
      <SubMenuTest/>
    </div>
  )
}

const MenuItem = styled(UnstyledMenuItem)`

`

const Title = styled(BodyText)`
  font-size: ${theme.font.size.h2};
`

const SubMenu = styled.div`
  
`

export default MenuItem